// billing-plugin/common/schemas/collections/recurrenceRule.js
import { z } from "zod";

/**
 * A structured schema for defining recurring time intervals, inspired by iCalendar's RRULE.
 * This allows for flexible scheduling like "every 2 weeks on Monday" or "on the 15th of every month".
 */
const RecurrenceRuleSchema = z.object({
    frequency: z.enum(['daily', 'weekly', 'monthly', 'yearly', 'never', 'based_on_plan']),
    interval: z.number().int().positive().default(1).nullable().describe("e.g., frequency='weekly' and interval=2 means 'every 2 weeks'."),
    
    byDay: z.array(z.enum(['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'])).optional().nullable().describe("For weekly frequency, specifies which days of the week."),
    byMonthDay: z.number().int().min(1).max(31).optional().nullable().describe("For monthly frequency, specifies the day of the month."),
    byMonth: z.number().int().min(1).max(12).optional().nullable().describe("For yearly frequency, specifies the month of the year."),
});

export default RecurrenceRuleSchema;